import React from "react";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import { makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  text: {
    color: theme.orange,
    fontSize: 20,
  },
  textInput: {
    fontSize: 32,
    color: theme.orange,
    margin: "29px auto",
    justifyContent: "space-around",
    display: "flex",
    width: "426px",
    height: "66px",
    border: "1px solid rgba(250, 153, 23, 0.19)",
    boxSizing: "border-box",
    boxShadow: "inset 0px 4px 4px rgba(0, 0, 0, 0.25)",
    borderRadius: 5,
    backgroundColor: theme.midGray,
  },
  disabledText: {
    color: theme.orange + "!important",
  },
}));

function InputMoneyTextField({ className, onChange, key, disabled, value }) {
  const classes = useStyles();

  return (
    <OutlinedInput
      disabled={true}
      classes={{ root: classes.textInput, disabled: classes.disabledText }}
      endAdornment={<Typography className={classes.text}>THB</Typography>}
      value={Number(value).toLocaleString()}
    />
  );
  /*
  return (
    <NumberFormat
      customInput={InputMoneyOutlined}
      key={key}
      value={value}
      onChange={onChange}
      disabled={disabled ?? false}
      classes={{ root: classes.textInput, disabled: classes.disableText }}
      thousandSeparator={true}
    />
  );*/
}
/*
const InputMoneyOutlined = (props) => {
  const classes = useStyles();

  return (
    <OutlinedInput
      {...props}
      disabled={true}
      classes={{ root: classes.textInput, disabled: classes.disableText }}
      endAdornment={<Typography className={classes.text}>THB</Typography>}
    />
  );
};
*/
export default InputMoneyTextField;
